import {
  ServiceDescription,
  ServicePrice,
  StyledServiceList,
  StyledServiceRow,
} from "./style";

export const ExtendedServiceRow = ({ index, name, price, items }) => {
  return (
    <StyledServiceRow>
      <ServiceDescription>
        <span>
          {index}
          {")"} {name}
        </span>
        <StyledServiceList>
          {items.map((val, idx) => (
            <li key={name + idx}>{val}</li>
          ))}
        </StyledServiceList>
      </ServiceDescription>
      <ServicePrice>{price},- €</ServicePrice>
    </StyledServiceRow>
  );
};
